module.exports = __webpack_public_path__ + "static/media/Check.2094855c.svg";